import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toZendeskDueAtNoon(d: Date): string {
  const due = new Date(d);
  due.setHours(12, 0, 0, 0); // noon (local), same day
  return due.toISOString();
}
